import { SvgIcon } from "@mui/material";

const BlueTrash = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M14.4188 1.5C14.9049 1.5 15.3509 1.78088 15.5679 2.22557L15.8571 2.8125H19.7143C20.4254 2.8125 21 3.40025 21 4.125C21 4.84975 20.4254 5.4375 19.7143 5.4375H4.28571C3.57576 5.4375 3 4.84975 3 4.125C3 3.40025 3.57576 2.8125 4.28571 2.8125H8.14286L8.43214 2.22557C8.64911 1.78088 9.09509 1.5 9.58125 1.5H14.4188Z"
        fill="#011E3D"
      />
      <path
        d="M19.7137 19.875C19.7137 21.3229 18.5606 22.5 17.1423 22.5H6.85658C5.43627 22.5 4.28516 21.3229 4.28516 19.875V5.4375H19.7137V19.875ZM8.78516 8.71875C8.78516 8.35781 8.49587 8.0625 8.1423 8.0625C7.78873 8.0625 7.49944 8.35781 7.49944 8.71875V17.9062C7.49944 18.2672 7.78873 18.5625 8.1423 18.5625C8.49587 18.5625 8.78516 18.2672 8.78516 17.9062V8.71875ZM12.6423 8.71875C12.6423 8.35781 12.353 8.0625 11.9994 8.0625C11.6459 8.0625 11.3566 8.35781 11.3566 8.71875V17.9062C11.3566 18.2672 11.6459 18.5625 11.9994 18.5625C12.353 18.5625 12.6423 18.2672 12.6423 17.9062V8.71875ZM16.4994 8.71875C16.4994 8.35781 16.2102 8.0625 15.8566 8.0625C15.503 8.0625 15.2137 8.35781 15.2137 8.71875V17.9062C15.2137 18.2672 15.503 18.5625 15.8566 18.5625C16.2102 18.5625 16.4994 18.2672 16.4994 17.9062V8.71875Z"
        fill="#2771EC"
      />
    </SvgIcon>
  );
};

export default BlueTrash;
